module.exports = "/_next/static/images/RegionalSegment@2x-0f456bf582b8308fa209bcc56e3cc277.webp";